import { div, li, span } from '|>/shared/h'
import { register } from '|>/shared/vjs'
import { BaseMenuItem } from '../../../base'
import { getTextTrackCustomSettings } from '../text-track-custom-settings'

/**
 * Interface for any component that can trigger events
 */
interface IEventContainer {
  trigger(event: string, data?: any): void
}

/**
 * Universal subtitles custom menu item
 * Shows label and current selected value
 */
@register
export class SettingsSubtitlesCustomMenuItem extends BaseMenuItem {
  declare options_: any
  declare container: IEventContainer | undefined
  declare labelEl_: HTMLSpanElement
  declare activeCustomEl_: HTMLDivElement

  override createEl() {
    return li('.vjs-menu-item.vjs-x-menu-subtitles-nested-item', [
      (this.labelEl_ = span(
        '.vjs-menu-item-text',
        this.localize(this.options_.label)
      )),
      (this.activeCustomEl_ = div('.vjs-x-active-track')),
    ])
  }

  override handleClick() {
    if (this.options_.event) {
      this.container?.trigger(this.options_.event)
    }
  }

  update() {
    const { settingKey, getDisplayValue, isPercentage } = this.options_

    if (settingKey && this.activeCustomEl_) {
      const currentSettings = getTextTrackCustomSettings()
      const currentValue =
        currentSettings[settingKey as keyof typeof currentSettings]

      // Get display value (with custom formatting if provided)
      let translationKey: string
      if (getDisplayValue && typeof getDisplayValue === 'function') {
        translationKey = getDisplayValue(currentValue)
      } else {
        translationKey = String(currentValue)
      }

      // Apply localization to the formatted value
      let displayValue = this.localize(translationKey)

      // Add percentage suffix if needed
      if (isPercentage) {
        displayValue = `${displayValue}%`
      }

      // Update the display element
      this.activeCustomEl_.textContent = displayValue
    }
  }
}

SettingsSubtitlesCustomMenuItem.options = {
  label: '',
  event: '',
  settingKey: '',
  getDisplayValue: undefined,
  isPercentage: false,
}
